(() => {
  const root = document.getElementById('guide-showcase');
  if (!root) return;
  const visual = root.querySelector('.guide-showcase__visual');
  const books = [...root.querySelectorAll('.guide-showcase__book')];
  const choices = [...root.querySelectorAll('.guide-showcase__choices button')];
  const detail = root.querySelector('.guide-showcase__detail');
  const link = root.querySelector('.guide-showcase__link');
  const descriptions = {
    partenza: 'Documenti e primi passi per preparare la partenza.',
    lavoro: 'CV, candidature e preparazione ai colloqui.',
    completo: 'Tutti i contenuti, con consulenza privata.'
  };
  root.querySelectorAll('[data-guide]').forEach(button => {
    button.addEventListener('click', () => {
      const guide = button.dataset.guide;
      if (!descriptions[guide]) return;
      visual.classList.remove('is-entering');
      books.forEach(book => book.classList.toggle('is-selected', book.dataset.guide === guide));
      choices.forEach(choice => choice.setAttribute('aria-pressed', String(choice.dataset.guide === guide)));
      detail.textContent = descriptions[guide];
      link.href = '#pkg-' + guide;
    });
  });
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    visual.classList.add('is-entering');
    const observer = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      requestAnimationFrame(() => requestAnimationFrame(() => visual.classList.remove('is-entering')));
      observer.disconnect();
    }, { threshold: 0.2 });
    observer.observe(visual);
  }
})();
